/* Kabla Veterinaria — Landing Section behaviour (vanilla JS, no framework).
   Reads/writes only within elements scoped under [data-kb-section].
   Uses the Shopify AJAX Cart API (/cart/add.js, /cart/change.js, /cart.js)
   so "Agregar" buttons add REAL variants once the .liquid markup wires
   data-variant-id from {{ product.selected_or_first_available_variant.id }}. */
(function () {
  "use strict";

  document.querySelectorAll("[data-kb-section]").forEach(initKablaSection);

  function initKablaSection(root) {
    initNavbar(root);
    initMobileMenu(root);
    initSearch(root);
    initCategoryMenu(root);
    initSolutionTabs(root);
    initFaq(root);
    initSpeciesFilmstrip(root);
    initAnimatedStats(root);
    initCartDrawer(root);
    initQtyControls(root);
    initAddToCart(root);
  }


/* ---------- NAVBAR: transparente -> sólido al hacer scroll ---------- */

/* ---------- NAVBAR: sigue la promo y se fija arriba ---------- */
function initNavbar(root) {
  const nav = root.querySelector("[data-kb-nav]");
  const promo = root.querySelector(".kb-promo");

  if (!nav || !promo || nav.dataset.kbNavInitialized === "true") return;

  const container = document.querySelector("#PageContainer");

  nav.dataset.kbNavInitialized = "true";

  // Evitar que el transform del tema interfiera con position: fixed.
  if (container) {
    container.style.setProperty("transform", "none", "important");
  }

  const updateNavbar = () => {
    const promoBottom = promo.getBoundingClientRect().bottom;
    const passedPromo = promoBottom <= 0;

    // Cambiar colores y apariencia cuando la promo desaparece.
    nav.classList.toggle("is-scrolled", passedPromo);

    // Mantener el navbar debajo de la promo.
    // Cuando la promo sale de pantalla, fijarlo arriba.
    nav.style.setProperty(
      "top",
      passedPromo ? "0px" : `${Math.max(0, promoBottom)}px`,
      "important"
    );
  };

  updateNavbar();

  window.addEventListener("scroll", updateNavbar, { passive: true });
  window.addEventListener("resize", updateNavbar, { passive: true });
}


/* ---------- MENU MOVIL ---------- */
function initMobileMenu(root) {
  const nav = root.querySelector("[data-kb-nav]");
  if (!nav || nav.dataset.kbMobileInitialized === "true") return;

  const btn = nav.querySelector("[data-kb-burger]");
  const panel = nav.querySelector("[data-kb-mobile-panel]");

  if (!btn || !panel) return;

  nav.dataset.kbMobileInitialized = "true";

  const closeMenu = () => {
    panel.classList.remove("is-open");
    btn.setAttribute("aria-expanded", "false");
  };

  const toggleMenu = () => {
    const isOpen = panel.classList.toggle("is-open");
    btn.setAttribute("aria-expanded", String(isOpen));
  };

  btn.setAttribute("aria-expanded", "false");
  btn.setAttribute("aria-label", "Abrir o cerrar menú");
  btn.setAttribute("aria-controls", "kb-mobile-panel");

  panel.id = panel.id || "kb-mobile-panel";

  btn.addEventListener("click", (event) => {
    event.stopPropagation();
    toggleMenu();
  });

  panel.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", closeMenu);
  });

  document.addEventListener("click", (event) => {
    if (!nav.contains(event.target)) {
      closeMenu();
    }
  });

  nav.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeMenu();
      btn.focus();
    }
  });
}

/* ---------- MENU DE CATEGORIAS ---------- */
function initCategoryMenu(root) {
  const nav = root.querySelector("[data-kb-nav]");
  if (!nav || nav.dataset.kbCategoryInitialized === "true") return;

  const wrap = nav.querySelector("[data-kb-cat-wrap]");
  if (!wrap) return;

  const btn = wrap.querySelector("[data-kb-cat-toggle]");
  const menu = wrap.querySelector(".kb-nav__cat-menu");

  if (!btn || !menu) return;

  nav.dataset.kbCategoryInitialized = "true";

  const closeMenu = () => {
    wrap.classList.remove("is-open");
    btn.setAttribute("aria-expanded", "false");
  };

  const toggleMenu = () => {
    const isOpen = !wrap.classList.contains("is-open");

    wrap.classList.toggle("is-open", isOpen);
    btn.setAttribute("aria-expanded", String(isOpen));
  };

  btn.setAttribute("aria-expanded", "false");
  btn.setAttribute("aria-haspopup", "true");

  btn.addEventListener("click", (event) => {
    event.stopPropagation();
    toggleMenu();
  });

  menu.addEventListener("click", (event) => {
    if (event.target.closest("a")) {
      closeMenu();
    }
  });

  document.addEventListener("click", (event) => {
    if (!wrap.contains(event.target)) {
      closeMenu();
    }
  });

  wrap.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeMenu();
      btn.focus();
    }
  });
}


  /* ---------- search: filters a JSON payload rendered by Liquid ---------- */
  function initSearch(root) {
    const wraps = root.querySelectorAll("[data-kb-search]");
    wraps.forEach((wrap) => {
      const input = wrap.querySelector("[data-kb-search-input]");
      const resultsEl = wrap.querySelector("[data-kb-search-results]");
      const dataEl = root.querySelector("[data-kb-search-data]");
      if (!input || !resultsEl || !dataEl) return;
      let items = [];
      try { items = JSON.parse(dataEl.textContent || "[]"); } catch (e) { items = []; }

      const render = (q) => {
        const query = q.trim().toLowerCase();
        resultsEl.innerHTML = "";
        if (!query) { wrap.classList.remove("is-open"); return; }
        const matches = items.filter((p) =>
          p.title.toLowerCase().includes(query) || (p.vendor || "").toLowerCase().includes(query)
        ).slice(0, 6);
        if (matches.length === 0) {
          resultsEl.innerHTML = '<div class="kb-nav__search-empty">Sin resultados para "' + escapeHtml(q) + '"</div>';
        } else {
          matches.forEach((p) => {
            const a = document.createElement("a");
            a.href = p.url;
            a.className = "kb-nav__search-item";
            a.innerHTML =
              '<img class="kb-nav__search-thumb" src="' + escapeHtml(p.image || "") + '" alt="">' +
              '<div style="min-width:0">' +
              '<span style="font-size:9.5px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:#475569">' + escapeHtml(p.vendor || "") + "</span>" +
              '<p style="font-size:12.5px;font-weight:600;color:#0f172a;margin:1px 0 0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">' + escapeHtml(p.title) + "</p>" +
              "</div>";
            resultsEl.appendChild(a);
          });
        }
        wrap.classList.add("is-open");
      };

      input.addEventListener("input", (e) => render(e.target.value));
      input.addEventListener("focus", () => { if (input.value.trim()) wrap.classList.add("is-open"); });
      document.addEventListener("click", (e) => { if (!wrap.contains(e.target)) wrap.classList.remove("is-open"); });
    });
  }

  function escapeHtml(str) {
    const div = document.createElement("div");
    div.textContent = str;
    return div.innerHTML;
  }

  /* ---------- soluciones tabs (Más vendido / Recomendado / Nuevo) ---------- */
  function initSolutionTabs(root) {
    const tabs = root.querySelectorAll("[data-kb-tab]");
    if (!tabs.length) return;
    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        const key = tab.getAttribute("data-kb-tab");
        tabs.forEach((t) => t.classList.toggle("is-active", t === tab));
        root.querySelectorAll("[data-kb-panel]").forEach((p) => {
          p.classList.toggle("is-active", p.getAttribute("data-kb-panel") === key);
        });
      });
    });
  }

  /* ---------- FAQ accordion ---------- */
  function initFaq(root) {
    root.querySelectorAll("[data-kb-faq-item]").forEach((item) => {
      const btn = item.querySelector("[data-kb-faq-q]");
      const panel = item.querySelector("[data-kb-faq-a]");
      if (!btn || !panel) return;
      btn.addEventListener("click", () => {
        const isOpen = item.classList.contains("is-open");
        item.closest("[data-kb-faq-list]").querySelectorAll("[data-kb-faq-item]").forEach((other) => {
          other.classList.remove("is-open");
          other.querySelector("[data-kb-faq-a]").style.maxHeight = null;
        });
        if (!isOpen) {
          item.classList.add("is-open");
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      });
    });
  }

  /* ---------- species filmstrip: hover-expand handled in CSS; tap-to-expand on touch ---------- */
  function initSpeciesFilmstrip(root) {
    const cards = root.querySelectorAll("[data-kb-species-card]");
    if (!cards.length) return;
    const isTouch = window.matchMedia("(hover: none)").matches;
    if (!isTouch) return;
    cards.forEach((card) => {
      card.addEventListener("click", (e) => {
        if (card.classList.contains("is-expanded")) return;
        e.preventDefault();
        cards.forEach((c) => c.classList.remove("is-expanded"));
        card.classList.add("is-expanded");
      });
    });
  }

  /* ---------- animated stat counters + circular progress ("monitor animado") ---------- */
  function initAnimatedStats(root) {
    const bars = root.querySelectorAll("[data-kb-stat]");
    const rings = root.querySelectorAll("[data-kb-ring]");
    if (!bars.length && !rings.length) return;

    const animateCount = (el) => {
      const target = parseFloat(el.getAttribute("data-kb-stat"));
      const suffix = el.getAttribute("data-kb-suffix") || "";
      const start = performance.now();
      const duration = 1200;
      const tick = (now) => {
        const p = Math.min(1, (now - start) / duration);
        el.textContent = Math.round(p * target) + suffix;
        if (p < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };

    const animateRing = (el) => {
      const circle = el.querySelector("circle[data-kb-ring-fill]");
      if (circle) circle.style.animation = "kbShieldFill 2.2s ease-out forwards";
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        if (entry.target.hasAttribute("data-kb-stat")) animateCount(entry.target);
        if (entry.target.hasAttribute("data-kb-ring")) animateRing(entry.target);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.4 });

    bars.forEach((el) => observer.observe(el));
    rings.forEach((el) => observer.observe(el));
  }

  /* ---------- cart drawer + Shopify AJAX cart ---------- */
  function initCartDrawer(root) {
    const overlay = root.querySelector("[data-kb-cart-overlay]");
    const drawer = root.querySelector("[data-kb-cart-drawer]");
    const openBtns = root.querySelectorAll("[data-kb-cart-open]");
    const closeBtns = root.querySelectorAll("[data-kb-cart-close]");
    if (!drawer) return;

    const open = () => { drawer.classList.add("is-open"); if (overlay) overlay.classList.add("is-open"); };
    const close = () => { drawer.classList.remove("is-open"); if (overlay) overlay.classList.remove("is-open"); };

    openBtns.forEach((b) => b.addEventListener("click", open));
    closeBtns.forEach((b) => b.addEventListener("click", close));
    if (overlay) overlay.addEventListener("click", close);

    root._kbCartOpen = open;
    refreshCart(root);
  }

  function refreshCart(root) {
    fetch("/cart.js")
      .then((r) => r.json())
      .then((cart) => renderCart(root, cart))
      .catch(() => {});
  }

  function renderCart(root, cart) {
    const countEls = root.querySelectorAll("[data-kb-cart-count]");
    countEls.forEach((el) => { el.textContent = cart.item_count > 9 ? "9+" : cart.item_count; });
    root.querySelectorAll("[data-kb-cart-has]").forEach((el) => {
      el.style.display = cart.item_count > 0 ? "" : "none";
    });

    const itemsEl = root.querySelector("[data-kb-cart-items]");
    const emptyEl = root.querySelector("[data-kb-cart-empty]");
    const footEl = root.querySelector("[data-kb-cart-foot]");
    if (!itemsEl) return;

    if (!cart.items.length) {
      itemsEl.innerHTML = "";
      itemsEl.style.display = "none";
      if (emptyEl) emptyEl.style.display = "flex";
      if (footEl) footEl.style.display = "none";
      return;
    }
    itemsEl.style.display = "flex";
    if (emptyEl) emptyEl.style.display = "none";
    if (footEl) footEl.style.display = "block";

    itemsEl.innerHTML = cart.items.map((item) => (
      '<div class="kb-cart-line" data-line-key="' + item.key + '">' +
      '<img src="' + (item.image || "") + '" alt="">' +
      '<div class="kb-cart-line-info">' +
      '<span class="kb-cart-line-brand">' + escapeHtml(item.vendor || "") + "</span>" +
      '<p class="kb-cart-line-name">' + escapeHtml(item.product_title) + "</p>" +
      "</div>" +
      '<div class="kb-qty">' +
      '<button type="button" data-kb-cart-dec="' + item.key + '">−</button>' +
      "<span>" + item.quantity + "</span>" +
      '<button type="button" data-kb-cart-inc="' + item.key + '">+</button>' +
      "</div>" +
      '<button type="button" class="kb-cart-line-remove" data-kb-cart-remove="' + item.key + '">×</button>' +
      "</div>"
    )).join("");

    const subtotalEl = root.querySelector("[data-kb-cart-subtotal]");
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    itemsEl.querySelectorAll("[data-kb-cart-inc]").forEach((b) => b.addEventListener("click", () => changeLine(root, b.getAttribute("data-kb-cart-inc"), 1)));
    itemsEl.querySelectorAll("[data-kb-cart-dec]").forEach((b) => b.addEventListener("click", () => changeLine(root, b.getAttribute("data-kb-cart-dec"), -1)));
    itemsEl.querySelectorAll("[data-kb-cart-remove]").forEach((b) => b.addEventListener("click", () => removeLine(root, b.getAttribute("data-kb-cart-remove"))));
  }

  function formatMoney(cents) {
    return "$" + (cents / 100).toLocaleString("es-MX", { minimumFractionDigits: 2 });
  }

  function changeLine(root, key, delta) {
    fetch("/cart.js").then((r) => r.json()).then((cart) => {
      const line = cart.items.find((i) => i.key === key);
      if (!line) return;
      const qty = Math.max(0, line.quantity + delta);
      fetch("/cart/change.js", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: key, quantity: qty }),
      }).then((r) => r.json()).then((updated) => renderCart(root, updated));
    });
  }

  function removeLine(root, key) {
    fetch("/cart/change.js", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: 0 }),
    }).then((r) => r.json()).then((updated) => renderCart(root, updated));
  }

  /* ---------- per-card quantity steppers (pre-add-to-cart) ---------- */
  function initQtyControls(root) {
    root.querySelectorAll("[data-kb-qty]").forEach((wrap) => {
      const span = wrap.querySelector("[data-kb-qty-value]");
      const dec = wrap.querySelector("[data-kb-qty-dec]");
      const inc = wrap.querySelector("[data-kb-qty-inc]");
      if (!span) return;
      const get = () => parseInt(span.textContent, 10) || 1;
      const set = (n) => { span.textContent = Math.max(1, n); };
      if (dec) dec.addEventListener("click", () => set(get() - 1));
      if (inc) inc.addEventListener("click", () => set(get() + 1));
    });
  }

  /* ---------- add to cart (real Shopify variants) ---------- */
  function initAddToCart(root) {
    root.querySelectorAll("[data-kb-add]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const variantId = btn.getAttribute("data-kb-add");
        const card = btn.closest("[data-kb-qty]") ? btn.closest(".kb-prod-card, .kb-prod-card__row") : null;
        const qtyEl = card ? card.querySelector("[data-kb-qty-value]") : null;
        const quantity = qtyEl ? parseInt(qtyEl.textContent, 10) || 1 : 1;
        if (!variantId) return;
        btn.disabled = true;
        fetch("/cart/add.js", {
          method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: variantId, quantity: quantity }),
        })
          .then((r) => r.json())
          .then(() => { refreshCart(root); if (root._kbCartOpen) root._kbCartOpen(); })
          .catch(() => {})
          .finally(() => { btn.disabled = false; });
      });
    });
  }
})();
